module.exports = __webpack_public_path__ + "img/潘玉良.735c455e.png";